module.exports = __webpack_public_path__ + "img/title-3.3e05ee50.png";